import '@webcomponents/shadydom/shadydom.min.js'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import './lib/polyfill-global-this'
import './lib/polyfill-number-is-nan'
import './lib/objectEntity'
import './lib/requestAnimationFrame'
import './lib/polyfill-array-includes'
import { fromJS } from 'immutable'
import React, { lazy } from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { mergeDeep } from './lib/mergeDeep'
import reportWebVitals from './reportWebVitals'
import { makeStore } from './store/project'
import { routes } from './Web/router'
import _ResizeObserver from 'resize-observer-polyfill'
import { registerLottieAPI } from './lib/registerLottieAPI'
import { PanelRender } from './components/Project/UI/PanelRender'
import { SURVEY_TYPE, SURVEY_EMAIL_TYPE } from './constants/features'
import { LAYOUT_MODE } from './constants/toUnits'
const TitanFileUpgradeLicenseDialog = lazy(() =>
  import('./components/Project/UI/Dialog/TitanFileUpgradeLicenseDlg').then((val) => ({
    default: val.TitanFileUpgradeLicenseDialog,
  }))
)

try {
  if (typeof window.ResizeObserver === 'undefined') {
    window.ResizeObserver = _ResizeObserver
  }
} catch (error) {
  console.error(error)
}

registerLottieAPI()

const getInitialState = (state = {}) => {
  if (_.get(state, ['project', 'ProjectType']) == 'surveyEmail') {
    return fromJS(state)
  }
  let appState = mergeDeep({}, state, window.__FT__APP__STATE || {})
  if (typeof window !== 'undefined' && window.location.href.indexOf('ftnocache') === -1) {
    _.set(appState, 'project.Settings.debugModeSettings.skipValidations', false)
  }
  const shuffleQuestion = _.get(appState, ['project', 'Settings', 'survey', 'shuffleQuestion'], false)
  if (
    shuffleQuestion &&
    [SURVEY_TYPE, SURVEY_EMAIL_TYPE].includes(_.get(appState, ['project', 'ProjectType'], 'web'))
  ) {
    let page = appState.currentPage
    let rootID = _.get(appState, ['pages', page, 'Props', 'Grid', 0])
    let tabs = _.get(appState, ['pages', page, 'Props', 'elements', rootID, 'props', 'lg', 'tabs'], [])
    let start = _.filter(tabs, (v) => v.isStart)
    let end = _.filter(tabs, (v) => v.isFinish)
    let rest = _.shuffle(_.filter(tabs, (v) => !v.isFinish && !v.isStart))
    _.each(LAYOUT_MODE, (mode) => {
      _.set(appState, ['pages', page, 'Props', 'elements', rootID, 'props', mode, 'tabs'], [...start, ...rest, ...end])
    })
  }
  fromJS(appState)
}

const store = makeStore(getInitialState())

let rootElem = document.getElementById('__next')
if (!rootElem) {
  rootElem = document.createElement('div')
  rootElem.setAttribute('id', '__next')
  document.body.appendChild(rootElem)
}
const root = ReactDOM.createRoot(rootElem)
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <PanelRender path={['panels', 'FILES_LIMIT_REACHED', 'open']}>
        <TitanFileUpgradeLicenseDialog />
      </PanelRender>
      {routes}
    </Provider>
  </HelmetProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
